import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle, memo } from 'react';
import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    DialogTitle,
    Tooltip,
    ButtonGroup,
    Badge,
    Chip,
    Typography
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { globalstyles } from '../lib/definitions';
import { AddBox, Backspace, Check, CheckBox, CheckBoxOutlineBlank, CheckBoxOutlined, Checklist, Close, EmojiEvents, ErrorOutline, FactCheck, Grading, IndeterminateCheckBox, PictureAsPdf, PlayArrow, RemoveCircle, Rule, Save, Square, SquareOutlined, Stop, TaskAlt, WarningAmber } from '@mui/icons-material';
import { useEvent } from '../context/eventContext';
import { ContainerPdfDialog } from './PdfContainerDialog';
import { get_Cow_byID } from '../FirebaseUtils/dbCow';
import { getSelectedElement, propComparatorDate } from '../utils/ui_utils';
import { NumberInput } from '../components/NumberInput';
import { getPointData, getFilteredList } from '../definitions/match';
import { getSummaryData } from '../definitions/cow';
import MatchDocumentMenu from '../components/menu/MatchDocumentMenu';
import MatchDocumentDividerMenu from '../components/menu/MatchDocumentDividerMenu';


const pre_document_list = [
    { id: 'prering', label: 'lista prering', icon: (p) => <Rule {...p} /> },
    { id: 'prering', label: 'lista prering (includi soggetti non presenti)', show_all: true, icon: (p) => <Rule {...p} /> },
    { id: 'prering_light', label: 'lista prering light', icon: (p) => <Grading {...p} /> },
    { id: 'prering_light', label: 'lista prering light (includi soggetti non presenti)', show_all: true, icon: (p) => <Grading {...p} /> },
    { id: 'result', label: 'gestione giudizi', icon: (p) => <TaskAlt {...p} /> },
    { id: 'result', label: 'gestione giudizi (includi soggetti non presenti)', show_all: true, icon: (p) => <TaskAlt {...p} /> },
]
const post_document_list = [
    { id: 'postpresence', label: 'report presenze', disabled_status: ['run', 'end'], icon: (p) => <FactCheck {...p} /> },
    { id: 'postresult', label: 'convalida risultati', disabled_status: ['end'], icon: (p) => <EmojiEvents {...p} /> },
    //    { id: 'summaryresult', label: 'riepilogo risultati', disabled_status: ['end'] },
]



const groupby_mode_dict = {
    cowlist: { id: 'cowlist', label: 'soggetti' },
    cowman: { id: 'cowman', label: 'allevatori', title: 'soggetti raggruppati per allevatore' },
    property: { id: 'property', label: 'aziende', title: 'soggetti raggruppati per azienda' },
    prov: { id: 'prov', label: 'province', title: 'soggetti raggruppati per provincia' },
}


export const MatchDocumentsDialog = forwardRef(({ cow_list }, ref) => {
    const pdfRef = useRef()
    const [open, setOpen] = useState(false);
    const [cur_match_list, setCurMatchList] = useState([])
    const [is_multi, setIsMulti] = useState(false)
    const [is_summary, setIsSummary] = useState(false)
    const { selEvent } = useEvent()
    const [selected_match_list, setSelectedMatchList] = useState([])
    const [selected_award_list, setSelectedAwardList] = useState([])
    const [summary_data_list, setSummaryDataList] = useState([])
    const [page_split, setPageSplit] = useState(false)
    const [c_height, setContentHeight] = useState('80vh')
    const [pivot, setPivot] = useState(-1)
    useImperativeHandle(ref, () => {
        return {
            onOpen(el, multi) {
                setSelectedAwardList([])
                setOpen(true);
                setSelectedMatchList([])
                setSummaryDataList([])
                setIsSummary(false)
                if (multi) {
                    setIsMulti(true)
                    setCurMatchList(el)
                } else {
                    setIsMulti(false)
                    setCurMatchList([el])
                }

            },
        }
    })


    const toggleSummary = (_id) => {
        setSummaryDataList(l => {
            let _l = [...l]
            const c = _l.indexOf(_id)
            if (c < 0) {
                _l.push(_id)
            } else {
                _l.splice(c, 1)
            }
            return _l

        })
    }


    const removeMatch = (a_id) => {
        setSelectedMatchList(l => {
            let _l = [...l]
            const _id = a_id
            const c = _l.map(c => c.id).indexOf(_id)
            if (c >= 0) {
                _l.splice(c, 1)
            }
            setPivot(_l.length - 1)
            return _l
        })

    }
    const toggleMatch = (i) => {
        setSelectedMatchList(l => {
            let _l = [...l]
            const c = _l.map(c => c.id).indexOf(i.id)
            if (c < 0) {
                _l.splice(pivot + 1, 0, i)
                //                _l.push(i)
            } else {
                _l.splice(c, 1)
            }
            setPivot(_l.length - 1)
            return _l
        })
    }
    const removeAward = (a_id) => {
        setSelectedAwardList(l => {
            let _l = [...l]
            const _id = a_id
            const c = _l.map(c => c.id).indexOf(_id)
            if (c >= 0) {
                _l.splice(c, 1)
            }
            setPivot(_l.length - 1)
            return _l
        })
    }


    const toggleDivider = (k) => {
        setSelectedAwardList(l => {
            let _l = [...l]
            if (k) {
                _l.splice(k, 1)
            } else {
                _l.splice(pivot + 1, 0, { type: 'divider' })
                //                _l.push({ type: 'divider' })
            }
            setPivot(_l.length - 1)
            return _l
        })
    }
    const toggleMultiDivider = (match) => {
        setSelectedAwardList(l => {
            let _l = []
            for (let k = 0; k < l.length; k++) {
                const el = l[k]
                const el_p = l[k + 1]
                _l.push(el)
                if (el_p && el.type !== 'divider' && el_p.type !== 'divider') {
                    if (!match || el.id.split("_")[0] !== el_p.id.split("_")[0]) {
                        _l.push({ type: 'divider' })
                    }
                }
            }
            setPivot(_l.length - 1)
            console.log("_list", _l)
            return _l
        })
    }

    const toggleAward = (m, r) => {
        setSelectedAwardList(l => {
            let _l = [...l]
            const _id = m.id + "_" + r.id
            const c = _l.map(c => c.id).indexOf(_id)
            if (c < 0) {
                const a = getSelectedElement(r.id, m.result_list, 'id')
                console.log("AWARD result", m, r, a, !a || !a.cow_list)
                let cl = []
                if (a && a.cow_list) {
                    cl = getFilteredList(m.id, m.result_list, m.cow_list, a.id).cow_list
                    console.log("CL", cl)
                } else {
                    const _el = getPointData(m, cur_match_list, cow_list)
                    if (_el.length > 0) {
                        const _f_el = _el.filter(pr => pr.id === r.id)
                        if (_f_el.length > 0) {
                            cl = _f_el[0].data_list
                        }
                    }
                }
                let ml = 1
                if (m.export_position_limit && parseInt(m.export_position_limit) !== 0) {
                    ml = parseInt(m.export_position_limit)
                    if (a.from_other_data) {
                        ml = 1
                    }
                } else if (a && a.cow_list && a.cow_list.length > 0) {
                    ml = cl.length
                }
                const s = {
                    match_name: m.match_name,
                    award: r,
                    cow_list: cl,
                    id: _id,
                    group_data: !a || !a.cow_list,
                    award_label: r.has_position ? m.award_label_list : undefined,
                    max_limit: ml,
                    total_length: r.has_position || r.from_other_data ? cl.length : 1
                }
                _l.splice(pivot + 1, 0, s)
                //                _l.push(s)
            } else {
                _l.splice(c, 1)
            }
            setPivot(_l.length - 1)
            return _l
        })
    }


    const updateAwardData = (c, cl) => {
        setSelectedAwardList(l => {
            let _l = [...l]
            const s = {
                ..._l[c],
                [cl.name]: cl.value
            }
            _l.splice(c, 1, s)
            return _l
        })
        console.log(c, cl.name)
    }


    const handleClose = () => {
        setOpen(false);
    };

    const getRealCow = async (c) => {
        //      console.log(c)
        const res = getSelectedElement(c.id, cow_list, 'id') //await get_Cow_byID(selEvent.id, c.id)
        //        console.log("COW GET ID", res)
        return res
    }



    const getCowList = async (m, show_all) => {
        console.log("getCowList match", m)
        if (m.cow_list && m.cow_list.length > 0) {
            console.log("PRESENCE DONE (show_all)", show_all)
            if (show_all) {
                const c_listb = await Promise.all(
                    m.cow_list.map(async c => ({ ...c, ...await getRealCow(c) }))
                )
                const c_index = m.cow_list.map(c => c.id)
                console.log("SHOW ALL", m, m.linked_cow_list, c_index)
                const link_cow_list = m.linked_cow_list || cow_list.filter(c => c.category && c.category.id === m.linked_category?.id)
                if (link_cow_list) {
                    for (const c of link_cow_list) {
                        if (!c_index.includes(c.id)) {
                            console.log("NOT INCLU")
                            c_listb.push(c)
                        }
                    }
                }
                console.log("-----return ", c_listb)
                if (m.dynamic_cow_list) {
                    return c_listb
                } else {
                    return c_listb.sort(propComparatorDate('birthdate', true, 'catalog_id'))
                }
            } else {
                if (m.dynamic_cow_list) {
                    return await Promise.all(m.cow_list.map(async c => ({ ...c, ...await getRealCow(c) })))
                } else {
                    return await Promise.all(m.cow_list.sort(propComparatorDate('birthdate', true, 'catalog_id')).map(async c => ({ ...c, ...await getRealCow(c) })))
                }
            }
        } else if (m.dynamic_cow_list && m.dynamic_cow_list.length > 0) {
            console.log("DYNBAMIC")
            return m.dynamic_cow_list.filter(c => show_all === true || c.is_present === true)
        } else if (m.linked_cow_list && m.linked_cow_list.length > 0) {
            console.log("LINKED")
            return m.linked_cow_list.sort(propComparatorDate('birthdate', true, 'catalog_id')).filter(c => show_all === true || c.is_present === true)
        } else if (m.link_to_category) {
            return cow_list?.filter(c => c.category && c.category.id === m.linked_category?.id && (show_all === true || c.is_present === true)).sort(propComparatorDate('birthdate', true, 'catalog_id'))
        }

    }


    const handlePdfSummary = async () => {
        const d_list = []
        for (const a of selected_award_list) {
            console.log("AWARD", a)
            if (a.type === 'divider') {
                d_list.push(a)
            } else {

                let t = {
                    id: a.id,
                    section_title: `${a.match_name}: ${a.award?.award_name}`,
                    award_label: a.award_label
                }
                if (a.group_data) {
                    t.element_list = a.cow_list.filter((c, k) => k < a.max_limit)
                } else {
                    t.cow_list = await getCowList({ cow_list: a.cow_list.filter((c, k) => k < a.max_limit && c.cow).map(c => c.cow), dynamic_cow_list: true })
                    if (a.award.from_other_data) {
                        t.award_value = a.award.award_value
                    }
                }
                d_list.push(t)
            }
        }
        console.log("INIT COW LIST SUMMARY", cow_list)
        const doc_data = {
            data_list: d_list,
            title: 'riepilogo mostra',
            summary_data: summary_data_list.map(s => {
                return {
                    title: groupby_mode_dict[s].label,
                    data_list: getSummaryData(s, cow_list).filter(l => l.cow_list ? l.cow_list.filter(c => c.is_present).length > 0 : l.is_present)
                }
            }
            )
        }
        pdfRef.current.onOpen(doc_data, 'riepilogo mostra', 'globalsummary')
    }


    const handlePdf = async (index, l, p, show_all) => {
        let doc_data = { section_title: 'titolo', cow_list: [] }
        console.log("HANDLE PDF: index, type", index, p, "SHOWALL:", show_all)
        if (index !== undefined) {
            const m = cur_match_list[index]
            doc_data = {
                id: m.id,
                section_title: `${m.match_name} ${m.match_description && m.match_description.length > 0 ? '- ' + m.match_description : ''}`,
                cow_list: await getCowList(m, show_all),
                result_list: m.result_list,
                other_options: {
                    hide_not_in_ring: m.hide_not_in_ring,
                    hide_not_qualified: m.hide_not_qualified
                }
            }
        } else {
            const d_list = []
            for (const m of selected_match_list) {
                d_list.push(
                    {
                        id: m.id,
                        section_title: `${m.match_name} ${m.match_description && m.match_description.length > 0 ? '- ' + m.match_description : ''}`,
                        cow_list: await getCowList(m, show_all),
                        result_list: m.result_list,
                        other_options: {
                            hide_not_in_ring: m.hide_not_in_ring,
                            hide_not_qualified: m.hide_not_qualified
                        }
                    }
                )
            }
            doc_data = { data_list: d_list, page_split: page_split }

        }
        console.log("----===---DOC DATA DEBUG", doc_data)
        pdfRef.current.onOpen(doc_data, l, p)
    }

    useEffect(() => {
        if (is_summary) {
            setPivot(selected_award_list.length - 1)
        } else {
            setPivot(selected_match_list.length - 1)
        }

    }, [is_summary])

    return (


        <Dialog open={open} onClose={handleClose} maxWidth={is_multi ? "xl" : 'md'} fullScreen={is_multi} fullWidth={true} disableEscapeKeyDown>
            <ContainerPdfDialog ref={pdfRef} />
            <DialogTitle>
                <Grid container flexDirection={"column"}>
                    {is_multi ?
                        <Grid container alignItems={"center"} justifyContent={"space-around"}>
                            <Grid size="auto" >
                                Documenti gare
                            </Grid>
                            {is_summary ?

                                <Grid size="auto">
                                    <Button variant="outlined" size="small" onClick={() => handlePdfSummary()} startIcon={<PictureAsPdf />}>stampa PDF</Button>
                                </Grid>
                                :

                                <>
                                    <Grid size="auto">
                                        <MatchDocumentMenu handlePdf={(d) => handlePdf(!is_multi ? 0 : undefined, d.label, d.id, d.show_all)} pre_document_list={pre_document_list} post_document_list={post_document_list} disabled={is_multi && selected_match_list.length === 0} />
                                    </Grid>
                                </>
                            }
                            <Grid size="auto">
                                <ButtonGroup size="small" color="secondary">
                                    <Button onClick={() => setIsSummary(false)} variant={is_summary === false ? 'contained' : 'outlined'}>documenti gare</Button>
                                    <Button onClick={() => setIsSummary(true)} variant={is_summary === true ? 'contained' : 'outlined'}>sommario</Button>
                                </ButtonGroup>
                            </Grid>
                        </Grid>
                        :
                        <Grid container alignItems={"center"} justifyContent={"space-around"}>
                            <Grid size="auto" >
                                Documenti gara
                            </Grid>
                            <Grid size="auto">
                                <Box sx={{ fontSize: '0.7em' }}>{cur_match_list[0]?.match_description}</Box>
                            </Grid>
                            <Grid size="auto">
                            </Grid>
                        </Grid>
                    }
                </Grid>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={1}>
                    {is_multi &&
                        <Grid size="grow">
                            <Grid container style={globalstyles.listHeader}>
                                <Grid size="grow">
                                    Gara
                                </Grid>
                                {is_summary ?
                                    <>
                                        <Grid size="grow">
                                            Premi assegnati
                                        </Grid>
                                        <Grid size="auto">
                                            <MatchDocumentDividerMenu
                                                toggleDivider={toggleDivider}
                                                toggleMultiDivider={toggleMultiDivider}
                                                disabled={selected_award_list.length < 2}
                                            />
                                        </Grid>
                                    </>
                                    :
                                    <Grid size="auto">
                                    </Grid>
                                }
                            </Grid>
                            <Box style={{ maxHeight: c_height, overflow: 'auto' }}>
                                {cur_match_list.map((m, k) => (
                                    <Grid key={k} container style={{ ...globalstyles.list_row, ...globalstyles.elem_row }}>
                                        <Grid size="grow" style={{ fontWeight: 'bold' }}>
                                            {m.match_name}
                                        </Grid>
                                        {is_summary ?
                                            <Grid size="grow">
                                                {m.award_list?.map((r, rk) => (
                                                    <Grid container key={rk} style={rk !== m.award_list.length - 1 ? globalstyles.list_row : {}}>
                                                        <Grid size="grow">
                                                            {r.award_name}
                                                        </Grid>
                                                        <Grid size="auto">
                                                            <Tooltip title={m.status !== 'end' ? "! Gara non terminata" : 'Aggiungi lista premio (dopo selezionato)'} placement="left">
                                                                <span>
                                                                    <Button style={{ minWidth: '30px' }} disabled={m.match_type !== 'auto' && m.status !== 'end'} variant={selected_award_list.map(s => s.id).includes(m.id + "_" + r.id) ? "contained" : "outlined"} onClick={() => toggleAward(m, r)} size="small" key={k}><AddBox style={{ fontSize: '0.8em' }} /></Button>
                                                                </span>
                                                            </Tooltip>
                                                        </Grid>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                            :
                                            <Grid size="auto">
                                                <Button style={{ minWidth: '30px' }} variant={selected_match_list.map(s => s.id).includes(m.id) ? "contained" : "outlined"} onClick={() => toggleMatch(m)} size="small" key={k}><AddBox style={{ fontSize: '0.8em' }} /></Button>
                                            </Grid>
                                        }
                                    </Grid>
                                ))}
                            </Box>
                        </Grid>}
                    {is_multi ?
                        <Grid size="grow">
                            {is_summary ?
                                <>
                                    <Grid container style={globalstyles.sectionHeader}>
                                        <Grid size="auto">
                                            <Button style={{ minWidth: '30px' }} color="error" disabled={summary_data_list.length === 0} variant={"contained"} onClick={() => setSummaryDataList([])} size="small" k><Backspace style={{ fontSize: '0.8em' }} /></Button>
                                        </Grid>
                                        <Grid size="auto">
                                            conteggi visualizzati
                                        </Grid>
                                    </Grid>
                                    {Object.values(groupby_mode_dict).map((m, k) => (
                                        <Grid key={k} container style={globalstyles.list_row}>
                                            <Grid size="auto">
                                                {summary_data_list.includes(m.id) ?
                                                    <Button variant={'contained'} onClick={() => toggleSummary(m.id)} size="small" key={k}><Check style={{ fontSize: '0.8em' }} /></Button>
                                                    :
                                                    <Button variant={'outlined'} onClick={() => toggleSummary(m.id)} size="small" key={k}><SquareOutlined style={{ fontSize: '0.8em' }} /></Button>
                                                }
                                            </Grid>
                                            <Grid size="grow">
                                                {m.label}
                                            </Grid>
                                        </Grid>
                                    ))}

                                    <Grid container style={{ ...globalstyles.sectionHeader, marginTop: 3 }}>
                                        <Grid size="auto">
                                            <Button style={{ minWidth: '30px' }} color="error" disabled={selected_award_list.length === 0} variant={"contained"} onClick={() => setSelectedAwardList([])} size="small" k><Backspace style={{ fontSize: '0.8em' }} /></Button>
                                        </Grid>
                                        <Grid size="grow">
                                            premi inseriti nella stampa ({selected_award_list.length})
                                        </Grid>
                                    </Grid>
                                    {selected_award_list.length === 0 ?
                                        <Typography style={globalstyles.missing_value}>
                                            <WarningAmber style={{ fontSize: '1em', color: 'orange' }} />
                                            Nessun premio inserito
                                        </Typography>
                                        :
                                        <Grid style={globalstyles.listHeader} container>
                                            <Grid size={1}>

                                            </Grid>
                                            <Grid size={"grow"}>
                                                Gara
                                            </Grid>
                                            <Grid size={"grow"}>
                                                Premio
                                            </Grid>
                                            <Grid size={"grow"}>
                                                Soggetti visualizzati (max)
                                            </Grid>
                                        </Grid>
                                    }
                                    {selected_award_list.map((a, k) => {
                                        if (a.type === 'divider') {
                                            return (
                                                <Grid container key={k} style={{ backgroundColor: 'orange', ...globalstyles.list_row }}>
                                                    <Grid size="auto">
                                                        <Button style={{ minWidth: '30px' }} color="error" variant={"outlined"} onClick={() => toggleDivider(k)} size="small" key={k}><IndeterminateCheckBox style={{ fontSize: '0.8em' }} /></Button>
                                                    </Grid>
                                                    <Grid size="auto">
                                                        <Button color="secondary" style={{ minWidth: '30px' }} variant={pivot === k ? "contained" : "outlined"} onClick={() => setPivot(k)} size="small" key={k}>{pivot === k ? <CheckBox style={{ fontSize: '0.8em' }} /> : <CheckBoxOutlineBlank style={{ fontSize: '0.8em' }} />}</Button>
                                                    </Grid>
                                                    <Grid size="grow">
                                                        SEPARATORE di pagina
                                                    </Grid>
                                                </Grid>

                                            )
                                        } else {
                                            return (
                                                <Grid container key={k} style={globalstyles.list_row}>
                                                    <Grid size="auto">
                                                        <Button style={{ minWidth: '30px' }} color="error" variant={"outlined"} onClick={() => removeAward(a.id)} size="small" key={k}><IndeterminateCheckBox style={{ fontSize: '0.8em' }} /></Button>
                                                    </Grid>
                                                    <Grid size="auto">
                                                        <Button color="secondary" style={{ minWidth: '30px' }} variant={pivot === k ? "contained" : "outlined"} onClick={() => setPivot(k)} size="small" key={k}>{pivot === k ? <CheckBox style={{ fontSize: '0.8em' }} /> : <CheckBoxOutlineBlank style={{ fontSize: '0.8em' }} />}</Button>
                                                    </Grid>
                                                    <Grid size="grow">
                                                        {a.match_name}
                                                    </Grid>
                                                    <Grid size="grow" style={{ fontSize: '0.8em' }}>
                                                        {a.award.award_name}
                                                    </Grid>
                                                    <Grid size={2}>
                                                        <NumberInput
                                                            value={a.max_limit || 0}
                                                            label={''}
                                                            name="max_limit" ey={k}
                                                            max_value={a.total_length}
                                                            onChangeHandler={(e) => updateAwardData(k, e)}
                                                        />
                                                    </Grid>
                                                    <Grid size="auto" style={{ paddingLeft: 6 }}>
                                                        <Typography style={{ fontSize: '0.8em', textAlign: 'center' }}>
                                                            set
                                                        </Typography>
                                                        <ButtonGroup size="small">
                                                            <Button onClick={() => updateAwardData(k, { name: 'max_limit', value: 1 })} style={{ padding: 0, minWidth: '30px' }}>1</Button>
                                                            {a.total_length >= 3 &&
                                                                <Button onClick={() => updateAwardData(k, { name: 'max_limit', value: 3 })} style={{ padding: 0, minWidth: '30px' }}>3</Button>
                                                            }
                                                            {a.total_length >= 5 &&
                                                                <Button onClick={() => updateAwardData(k, { name: 'max_limit', value: 5 })} style={{ padding: 0, minWidth: '30px' }}>5</Button>
                                                            }
                                                            <Button onClick={() => updateAwardData(k, { name: 'max_limit', value: a.total_length })} style={{ padding: 0, minWidth: '10px' }}>max({a.total_length})</Button>
                                                        </ButtonGroup>
                                                    </Grid>
                                                </Grid>

                                            )
                                        }
                                    }
                                    )}
                                </>
                                :
                                <>
                                    <Grid size="auto">
                                        <ButtonGroup size="small">
                                            <Button onClick={() => setPageSplit(false)} variant={page_split === false ? 'contained' : 'outlined'} startIcon={page_split === false ? <CheckBox /> : <CheckBoxOutlineBlank />}>documento singolo</Button>
                                            <Button onClick={() => setPageSplit(true)} variant={page_split === true ? 'contained' : 'outlined'} startIcon={page_split === true ? <CheckBox /> : <CheckBoxOutlineBlank />}>dividi pagine</Button>
                                        </ButtonGroup>
                                    </Grid>
                                    <Grid container style={{ ...globalstyles.sectionHeader, marginTop: 3 }}>
                                        <Grid size="auto">
                                            <Button style={{ minWidth: '30px' }} color="error" disabled={selected_match_list.length === 0} variant={"contained"} onClick={() => setSelectedMatchList([])} size="small" ><Backspace style={{ fontSize: '0.8em' }} /></Button>
                                        </Grid>
                                        <Grid size="grow">
                                            gare inserite nella stampa ({selected_match_list.length})
                                        </Grid>
                                    </Grid>
                                    {selected_match_list.map((a, k) => (
                                        <Grid container key={k} style={globalstyles.list_row}>
                                            <Grid size="auto">
                                                <Button color="error" style={{ minWidth: '30px' }} variant={"outlined"} onClick={() => removeMatch(a.id)} size="small" key={k}><IndeterminateCheckBox style={{ fontSize: '0.8em' }} /></Button>
                                            </Grid>
                                            <Grid size="auto">
                                                <Button color="secondary" style={{ minWidth: '30px' }} variant={pivot === k ? "contained" : "outlined"} onClick={() => setPivot(k)} size="small" key={k}>{pivot === k ? <CheckBox style={{ fontSize: '0.8em' }} /> : <CheckBoxOutlineBlank style={{ fontSize: '0.8em' }} />}</Button>
                                            </Grid>
                                            <Grid size="grow">
                                                {a.match_name}
                                            </Grid>
                                        </Grid>
                                    ))}
                                    {selected_match_list.length === 0 &&
                                        <Typography style={globalstyles.missing_value}>
                                            <WarningAmber style={{ fontSize: '1em', color: 'orange' }} />
                                            Nessuna gara inserita
                                        </Typography>
                                    }
                                </>
                            }
                        </Grid>

                        :
                        <Grid size="grow">
                            <Box sx={globalstyles.sectionHeader}>
                                Documenti preparatori
                            </Box>
                            {pre_document_list.map((d, k) => (
                                <Grid container key={k} sx={globalstyles.list_row}>
                                    <Grid size={"grow"}>
                                        {d.label}
                                    </Grid>
                                    <Grid size={2}>
                                        <Button disabled={is_multi && selected_match_list.length === 0} onClick={() => handlePdf(!is_multi ? 0 : undefined, d.label, d.id, d.show_all)} variant="outlined" size="small" startIcon={<PictureAsPdf style={{ color: !d.show_all ? 'lightblue' : 'orange' }} />} endIcon={<d.icon style={{ color: !d.show_all ? 'lightblue' : 'orange' }} />}></Button>
                                    </Grid>
                                </Grid>
                            ))}
                            <Box sx={globalstyles.sectionHeader}>
                                Report conclusivi
                            </Box>
                            {post_document_list.map((d, k) => (
                                <Grid container key={k} sx={globalstyles.list_row}>
                                    <Grid size={"grow"}>
                                        {d.label}
                                    </Grid>
                                    <Grid size={2}>
                                        <Button disabled={is_multi ? selected_match_list.length === 0 : !d.disabled_status.includes(cur_match_list[0]?.status)} onClick={() => handlePdf(!is_multi ? 0 : undefined, d.label, d.id, d.show_all)} variant="outlined" size="small" startIcon={<PictureAsPdf style={{ color: !d.show_all ? 'lightblue' : 'orange' }} />} endIcon={<d.icon style={{ color: !d.show_all ? 'lightblue' : 'orange' }} />}></Button>
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>
                    }

                </Grid>
            </DialogContent>
            <DialogActions>
                <ButtonGroup>
                    <Button variant='outlined' key={'bc'} onClick={handleClose} startIcon={<Close />}>Chiudi</Button>
                </ButtonGroup>
            </DialogActions>
        </Dialog>

    )

})


const DocumentListPre = ({ disabled, index, handlePdf }) => {
    return (
        <>
            <Box sx={globalstyles.sectionHeader}>
                Documenti preparatori
            </Box>
            {pre_document_list.map((d, k) => (
                <Grid container key={k} sx={globalstyles.list_row}>
                    <Grid size={"grow"}>
                        {d.label}
                    </Grid>
                    <Grid size={2}>
                        <Button color={d.show_all ? "secondary" : "primary"} disabled={disabled} onClick={() => handlePdf(index, d.label, d.id, d.show_all)} variant="outlined" size="small" startIcon={<PictureAsPdf />}></Button>
                    </Grid>
                </Grid>
            ))}
        </>

    )
}

